import React from "react";
import Careers from "../components/Careers";
import NspGallery from "../components/NspGallery";



const CareersPage = () => {
  return (
    <>
      <Careers />
      <NspGallery />
    </>
  );
};

export default CareersPage;
